<template>
  <div
    class="loading-icon loading-icon--animate"
    :class="{
      'loading-icon--light': light,
    }"
  >
    <div v-html="preloaderSVG" />
  </div>
</template>

<script setup lang="ts">
import preloaderSVG from '@/assets/img/preloader.svg?raw';

withDefaults(defineProps<{ light?: boolean; animate?: boolean }>(), { animate: true });
</script>

<style lang="scss" scoped>
@property --anim-duration {
  syntax: '<time>';
  inherits: false;
  initial-value: 0.3s;
}

@keyframes fadeInSequence {
  0% {
    opacity: 0;
  }
  10%,
  100% {
    opacity: 1;
  }
}

.loading-icon {
  display: block;
  width: auto;
  height: 100%;
  max-width: 36px;
  max-height: 32px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  z-index: 11;
  transform-origin: center;
  transform: rotate(-15deg) scale(1.5);

  &--light {
    :deep(svg path) {
      fill: $color-white;
    }
  }

  &--animate {
    :deep(svg path) {
      opacity: 1;
      animation: fadeInSequence 1.8s ease-in-out infinite;
      fill: $color-brand-fnmz-green;

      /* Apply delay to each path based on its index */
      &:nth-child(1) {
        /* Start animation here */
        animation-delay: 0s;
      }
      &:nth-child(2) {
        animation-delay: var(--anim-duration);
      }
      &:nth-child(3) {
        animation-delay: calc(var(--anim-duration) * 2);
      }
      &:nth-child(4) {
        animation-delay: calc(var(--anim-duration) * 3);
      }
      &:nth-child(5) {
        animation-delay: calc(var(--anim-duration) * 4);
      }
    }
  }
}
</style>
